import { Link } from 'react-router-dom';
import { toFullUrl } from '../../config/api';
import { Music } from 'lucide-react';
import { ThemedPlayer } from '../ThemedPlayer';

export function MusicSection({ tracks, siteSettings, navigate, onTrackBuy, isVisible }) {
  if (!isVisible('tracks')) return null;

  const purchasable = tracks.filter(t => t.purchasable && t.price > 0);

  return (
    <section id="tracks" className="py-12 sm:py-16 px-4 sm:px-8 border-b border-[#262626]" data-testid="compact-player-section">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <p className="overline text-[var(--primary,#FF3B30)] mb-2">{siteSettings?.section_titles?.music_label || 'NOW PLAYING'}</p>
          <h2 className="font-cabinet text-3xl sm:text-4xl font-black uppercase tracking-tighter">
            {siteSettings?.section_titles?.music || 'BANGER BOOTH'}
          </h2>
        </div>
        <ThemedPlayer
          theme={siteSettings?.player_theme || 'classic'}
          tracks={tracks}
          onNavigate={() => navigate('/tracks')}
          artwork={siteSettings?.player_artwork || {}}
        />
        {purchasable.length > 0 && (
          <div className="mt-6 border border-[#262626] bg-[#141414]" data-testid="quick-buy-tracks">
            <div className="px-4 py-2 border-b border-[#262626] flex items-center justify-between">
              <span className="text-xs font-bold uppercase tracking-wider text-[var(--accent,#DAA520)]">Available for Purchase</span>
              <Link to="/store" className="text-[10px] text-[#A3A3A3] hover:text-[var(--primary,#FF3B30)] uppercase tracking-wider transition-colors">View Store</Link>
            </div>
            <div className="divide-y divide-[#262626]">
              {purchasable.slice(0, 5).map(track => (
                <div key={track.id} className="flex items-center gap-3 px-4 py-3 hover:bg-[#1A1A1A] transition-colors" data-testid={`quick-buy-track-${track.id}`}>
                  <div className="w-10 h-10 bg-[#262626] shrink-0 overflow-hidden">
                    {track.cover_image ? (
                      <img src={toFullUrl(track.cover_image)} alt={track.title} className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center"><Music className="w-4 h-4 text-[#666]" /></div>
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-bold truncate">{track.title}</p>
                    <p className="text-[10px] text-[#A3A3A3]">{track.artist}</p>
                  </div>
                  <div className="flex items-center gap-2 shrink-0">
                    {track.on_sale && track.sale_price != null ? (
                      <span className="font-mono text-sm font-bold text-[var(--accent,#DAA520)]">${track.sale_price.toFixed(2)}</span>
                    ) : (
                      <span className="font-mono text-sm font-bold text-[var(--primary,#FF3B30)]">${track.price.toFixed(2)}</span>
                    )}
                    <button onClick={() => onTrackBuy(track)}
                      className="px-3 py-1.5 bg-[var(--primary,#FF3B30)] hover:bg-white hover:text-[#0A0A0A] text-xs font-bold uppercase transition-colors"
                      data-testid={`buy-track-home-${track.id}`}>
                      BUY
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
